import React, { useState } from 'react';
import {
  LoadingOutlined
} from '@ant-design/icons';
import './RefreshViewsButton.css';
import {variables} from '../../Variables.js';
import axiosService from '../../helpers/axios';

const RefreshViewsButton = ({button_text = "Refresh All Views", isAllViews = false}) => {
  const [isLoading, setIsLoading] = useState(false);
  const styleBtnRefresh = { height: "28px", fontSize: "12px", textAlign: "center", color: "white" };
  const classBtnAllViews = "btn-blue";
  const classBtnPartialViews = "btn btn-success";

  const refreshViews = async () => {
    try {
      setIsLoading(true);

      const endpoint = isAllViews ? '/refresh_materialized_view/' : '/refresh_partial_mvs/';
      const response = await axiosService.post(endpoint);
      const data = response.data;
      
      setIsLoading(false);
      setTimeout(() => {
        alert('Data updated successfully');
      }, 100);
      
    } catch (error) {
      setIsLoading(false);
      alert('Failed: ' + (error?.response?.data?.error || error?.message || 'Unknown error'));
    } finally {
      setIsLoading(false);
      }
  };
  
  return (
    <div>
      {/* Refresh Button */}
      <button 
        onClick={refreshViews}
        disabled={isLoading}
        className={isAllViews ? classBtnAllViews : classBtnPartialViews}
        style={styleBtnRefresh}
      >
        {isLoading ? 'Refreshing...' : button_text}
      </button>
      
      {/* Loading Modal */}
      {isLoading && (
        <div className="modal-overlay">
          <div className="modal-content-refresh">
            <div className="spinner-container">
              <div className="spinner">
                <LoadingOutlined />
              </div>
            </div>
            <h3 className="modal-title">Refreshing Views</h3>
            <p className="modal-text">
              Please wait while we refresh all materialized views...
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RefreshViewsButton;